//52
import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import { LegFinishMaterial, UpholsteryMaterial } from '../../utils/materials';

export function Stevie_sofa_x(props) {
  const { nodes, materials, scene } = useGLTF('models/Stevie Sofa - X.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);
  useSetMaterialFinish(
    UpholsteryMaterial,
    currentMaterialFinish.upholsteryFinish,
    defaultFinish.upholsteryFinish,
    'ao-stevie_sofa_x-upholstery',
    aoIntensity,
  );
  useSetMaterialFinish(
    LegFinishMaterial,
    currentMaterialFinish.legFinish,
    defaultFinish.legFinish,
    'ao-stevie_sofa_x-leg_finish',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Leg_Finish.geometry}
        material={LegFinishMaterial}
      />
      <mesh
        castShadow
        geometry={nodes.Upholstery.geometry}
        material={UpholsteryMaterial}
      />
      <Shadow model={'Stevie Sofa - X'} />
    </group>
  );
}
